module.exports = __webpack_public_path__ + "static/media/me.68360df7.jpg";